
import { useState } from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { 
  Sheet, 
  SheetContent, 
  SheetDescription, 
  SheetHeader, 
  SheetTitle, 
  SheetTrigger,
} from "@/components/ui/sheet";

export function NavbarSearch() {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  return (
    <Sheet open={isSearchOpen} onOpenChange={setIsSearchOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon">
          <Search className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent side="top">
        <SheetHeader>
          <SheetTitle>Αναζήτηση</SheetTitle>
          <SheetDescription>
            Αναζητήστε εκπαιδευτικό υλικό, μαθήματα και νέα
          </SheetDescription>
        </SheetHeader>
        <div className="mt-4 flex items-center space-x-2">
          <Input
            placeholder="Αναζήτηση..."
            className="flex-1"
            autoFocus
          />
          <Button>
            <Search className="mr-2 h-4 w-4" />
            Αναζήτηση
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
